var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.95833 3.41667V2.88333C9.95833 2.1366 9.95833 1.76323 9.80393 1.47801C9.6681 1.22713 9.45138 1.02316 9.18482 0.895325C8.88178 0.75 8.48507 0.75 7.69167 0.75H6.55833C5.76493 0.75 5.36822 0.75 5.06518 0.895325C4.79862 1.02316 4.58189 1.22713 4.44607 1.47801C4.29167 1.76323 4.29167 2.1366 4.29167 2.88333V3.41667M5.70833 7.08333V10.4167M8.54167 7.08333V10.4167M0.75 3.41667H13.5M12.0833 3.41667V10.8833C12.0833 12.0034 12.0833 12.5635 11.8517 12.9913C11.648 13.3676 11.3229 13.6736 10.9231 13.8653C10.4685 14.0833 9.87344 14.0833 8.68333 14.0833H5.56667C4.37656 14.0833 3.7815 14.0833 3.32694 13.8653C2.92709 13.6736 2.60201 13.3676 2.39828 12.9913C2.16667 12.5635 2.16667 12.0034 2.16667 10.8833V3.41667",
    stroke: "#DF0962",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/remove-icon.273074ed6fcd8d54acf352fcf58123b6.svg";
export { ForwardRef as ReactComponent };